{
  "template": {
    "type": "header-block",
    "title": "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    "description": "**Ut enim ad minim veniam** [quis nostrud](https://example.com) exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    "buttons": [
      {
        "text": "Button\r",
        "theme": "action",
        "url": "https://example.com"
      },
      {
        "text": "Button",
        "theme": "outlined",
        "url": "https://example.com"
      }
    ]
  }
}
